import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Logo from "./logo.mjs";


const TopNavBar = () => {
	const navigate = useNavigate();

	const firstName = sessionStorage.getItem('firstName');
	const lastName = sessionStorage.getItem('lastName');

	const handleLogout = () => {
		sessionStorage.clear();
		navigate("/");
	}

	return (
		<div className="navDiv" style={{position:'fixed', top:'0', width:'100%', zIndex:'100', boxShadow:'0px 2px 8px 0px rgba(0, 0, 0, 0.15)', display:'flex', flexDirection:'column', height:'140px'}}>
			<div className="navDiv"  style={{width:'1120px', paddingTop:'20px', paddingBottom:'26px', marginRight:'auto', marginLeft:'auto', display:'inline-block'}}>
				<div style={{display:'inline-block', width:'fit-content', height:'2.9rem', margin:'0px', padding:'0px', float:'left'}}>{Logo()}</div>
				<div style={{display:'inline-block', width:'fit-content', height:'2.9rem', margin:'0px', padding:'0px', marginLeft:'10px', float:'right'}} id="logoutIcon" onClick={handleLogout}>
					<i style={{display:'inline-block'}}><span style={{display:'inline-block', paddingTop:'10px'}} class="material-symbols-outlined">logout</span></i>
				</div>
				<div style={{display:'inline-block', width:'fit-content', height:'2.9rem', margin:'0px', padding:'0px', paddingTop:'7px', float:'right'}}>
					<p style={{margin:'0px', fontSize:'14px', display:'inline-block', paddingTop:'4px', cursor:'default'}}>Hi, {firstName + ' ' + lastName}</p>
				</div>
			</div>

			<div className="navigationHeader">
				<NavLink to="/dashboard" className="navButton">Dashboard</NavLink>
				<NavLink to="/manage-classes" className="navButton">Classes</NavLink>
				<NavLink to="/user-files" className="navButton">Files</NavLink>
				<NavLink to="/watchLivestream" className="navButton">Livestream</NavLink>
				<NavLink to="/contact" className="navButton">Support</NavLink>
			</div>
		</div>
        
    )
}

export default TopNavBar